import React, { Fragment } from "react";
import { makeStyles } from "@mui/styles";

import { BlockReasonText, CredentialBlock, CredentialResponse } from "../../services/Types"

const useStyles = makeStyles({
  loginStatusContent: {
    fontSize: "16px",
    margin: "-20px 0 11px",
  },
  loginStatusItem: {
    margin: "0 0 -2px",
  },
})

export const LoginStatusList = ({
  userCredentials, 
}: {
  userCredentials: CredentialResponse
}) => {
  const classes = useStyles();

  return (
    <>
      {!!userCredentials?.blocks?.length && (
        <div className={classes.loginStatusContent} data-testid="login-status-list">
          <h3>Login status:</h3>
          <div className={classes.loginStatusItem}>
            {userCredentials.blocks?.map(
              (credentialBlock: CredentialBlock) => (
                <div key={credentialBlock.id}>
                  <span>
                    {BlockReasonText[credentialBlock.type]}
                  </span>
                  {!!credentialBlock.blockedAt && (
                    <Fragment>
                      <span> - </span>
                      <span>
                        {new Date(
                          credentialBlock.blockedAt
                        ).toLocaleDateString()}
                      </span>
                    </Fragment>
                  )}
                </div>
              )
            )}
          </div>
        </div>
      )}
    </>
  )
}